import PropTypes from 'prop-types'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { useAuthStore } from 'features/auth/store/authStore'
import { useUserStore } from 'features/auth/store/userStore'

import SocketQueryInvalidator from './SocketQueryInvalidator'
import CacheSocketBridge from './CacheSocketBridge'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
})

// Query keys are not user-scoped, so drop every cached response (and the
// per-user UI state derived from it) when the session ends or the signed-in
// user changes. Token refreshes and buyer/seller role switches keep the cache.
let prevToken = useAuthStore.getState().token
let prevId = useAuthStore.getState().id
useAuthStore.subscribe(({ token, id }) => {
  const loggedOut = prevToken && !token
  const userChanged = prevId && id && String(prevId) !== String(id)
  prevToken = token
  prevId = id
  if (loggedOut || userChanged) {
    queryClient.clear()
    useUserStore.getState().reset()
  }
})

const QueryProvider = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <SocketQueryInvalidator />
    <CacheSocketBridge />
    {children}
  </QueryClientProvider>
)

QueryProvider.propTypes = {
  children: PropTypes.node,
}

export default QueryProvider
